import i18next from 'i18next';

import common_de from "./de/common.json";
import common_en from "./en/common.json";
import common_nl from "./nl/common.json";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        common: common_de
      },
      en: {
        common: common_en
      },
      nl: {
        common: common_nl
      }
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    },
    detection: {
      caches: []
    },
    preload: ['en']
  });

export default i18next;